<!-- Language Edit Modal -->
<div class="interaction-preview-modal"  [class.fullscreen]="!isModalView">
    <div class="modal-overlay" (click)="closeModal()"></div>
    <div class="modal-container" [class.loader-active]="isLoading">
        <div class="modal-header">
            <div class="header-label">Preview</div>
            <button class="close-button" (click)="closeModal()">
                <i class="fa fa-times lw2-modal-close"></i>
            </button>
        </div>

        <!-- <div class="modal-tabs">
            <button class="modal-tab" [class.active]="activeTab === 'basic'"
                (click)="setActiveTab('basic')">Basic</button>
            <button class="modal-tab" *ngIf="isEnableAdvanceTab()" [class.active]="activeTab === 'advanced'"
                (click)="setActiveTab('advanced')">Advanced</button>
        </div> -->
        <div class="modal-control-panel" *ngIf="!isLoading">
            <!-- <div class="modal-control-group">
                <button class="modal-link-control"> copy preview link </button>
            </div> -->
            <div class="modal-control-group">
                <button class="modal-link-control" (click)="copyToClipboard()" [disabled]="!isCopyEnabled"> 
                    <i class="fa fa-copy"></i> Copy Preview Link 
                </button>

                <button class="modal-control" [class.active]="previewDevice === 'desktop'" (click)="setPreviewUrl(url, 'desktop')">
                    <img src="./assets/images/desktop.svg"> Desktop
                </button>
                <button class="modal-control" [class.active]="previewDevice === 'phone'" (click)="setPreviewUrl(url, 'phone')">
                    <img src="./assets/images/mobile.svg"> Mobile
                </button>
                <button class="modal-control" [class.active]="previewDevice === 'tablet'" (click)="setPreviewUrl(url, 'tablet')">
                   <img src="./assets/images/tablet.svg"> Tablet
                </button>
            </div>
            <div class="modal-control-group"  *ngIf="isEnableAdvanceTab()">
                <button class="modal-control" (click)="showAdvancedConfig()">
                    advanced
                </button>
            </div>
        </div>

        <div class="modal-content"  *ngIf="!isLoading">
            <div class="page-edit-form" *ngIf="activeTab === 'basic'">
                <div class="row lw-conversation-studio-preview-row interaction-studio-peview-type-basic">
                    <!-- <div class="btn-group-vertical">
                        <button type="button" class="btn btn-default ltms-display-icon"
                            [class.ltms-display-icon-active]="previewDevice === 'phone'"
                            (click)="setPreviewUrl(url, 'phone')" style="border-radius: 0px!important;">
                            <i class="fa fa-mobile"></i>
                        </button>
                        <button type="button" class="btn btn-default ltms-display-icon"
                            [class.ltms-display-icon-active]="previewDevice === 'tablet'"
                            (click)="setPreviewUrl(url, 'tablet')" style="border-radius: 0px!important;">
                            <i class="fa fa-tablet"></i>
                        </button>
                        <button type="button" class="btn btn-default ltms-display-icon"
                            [class.ltms-display-icon-active]="previewDevice === 'desktop'"
                            (click)="setPreviewUrl(url, 'desktop')" style="border-radius: 0px!important;">
                            <i class="fa fa-desktop"></i>
                        </button>
                    </div> -->
                    <div class="text-center margin-20 page-error" *ngIf="!flowByDeaviceAndLang(previewDevice,default_language)">
                        <h5> {{errorMessage}} <span style="text-transform: capitalize; font:inherit;color: inherit;">{{previewDevice}}</span></h5>
                    </div>
                    <div *ngIf="flowByDeaviceAndLang(previewDevice,default_language)" class="preview-container"
                        [ngClass]="previewDevice=='phone'?'phone-preview':(previewDevice=='tablet'?'tablet-preview-studio':'desktop-preview')"
                        >
                        <iframe id="conversationPreviewIframeModal" style="border: 1px solid #eae5e5;" width="100%"
                            height="100%" frameborder="0"></iframe>
                    </div>
                </div>
            </div>
            <div class="config-panel-container" [class.show]="isConfigPanelOpen" *ngIf="isEnableAdvanceTab()">
                <div class="config-panel">
                    <div class="config-panel-header">
                        <div>Tag Value</div> 
                        <button (click)="hideAdvancedConfig()">
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                    <div class="config-panel-content">
                        <ul class="property-list">
                            <li *ngFor="let item of propertyData|keyvalue;" class="lw-conversation-studio-preview">
                                <label>{{item.key}}</label>
                                <input *ngIf="item.value.control === 'textbox'" type="{{item.value.type || 'text'}}"
                                    [(ngModel)]="item.value.value" placeholder="Type something" class="form-control " />
                                
                                <select class="" *ngIf="item.value.control === 'dropdown'" [(ngModel)]="item.value.value">
                                    <option value="">Select value</option>
                                    <option *ngFor="let option of item.value.options" [value]="option">{{option}}
                                    </option>
                                </select>
                            </li>
                        </ul> 
                    </div>
                    <div class="config-panel-footer">
                        <button (click)="clearPropertyValues()">Clear All</button>
                        <button class="primary" (click)="generateUrl()">Add</button>
                    </div>
                </div>
            </div>

            <!-- <div class="page-edit-form" *ngIf="activeTab === 'advanced' && isEnableAdvanceTab()">
                <div style="border-radius: 2px;" class="row lw-conversation-studio-preview-row">
                    <div class="col-sm-2" style="height: 70vh; overflow: auto;width: 11% !important;">
                        <ul class="preview-advance-property-list">
                            <li *ngFor="let item of propertyData|keyvalue;" class="lw-conversation-studio-preview">
                                <label>{{item.key}}</label>
                                <input *ngIf="item.value.control === 'textbox'" type="{{item.value.type || 'text'}}"
                                    [(ngModel)]="item.value.value" class="form-control custom-input" />
                                <label *ngIf="item.value.control === 'dropdown'" class="select">
                                    <select class="form-control" [(ngModel)]="item.value.value">
                                        <option value="">Value...</option>
                                        <option *ngFor="let option of item.value.options" [value]="option">{{option}}
                                        </option>
                                    </select>
                                </label>
                            </li>
                        </ul>
                        <button class="btn btn-success btn-md studio-new-button pull-right header-btn" style="background-color: #66b846;
                    box-shadow: none;" (click)="generateUrl()">Update</button>
                    </div>
                    <div class="col-sm-10 interaction-studio-preview-container">

                        <div style=" margin-left: -6px!important" class="btn-group-vertical">

                            <button type="button" class="btn btn-default ltms-display-icon"
                                [class.ltms-display-icon-active]="previewDevice === 'phone'"
                                (click)="setPreviewUrl(url, 'phone')"
                                style="border-radius: 0px!important;">
                                <i class="fa fa-mobile"></i>
                            </button>
                            <button type="button" class="btn btn-default ltms-display-icon"
                                [class.ltms-display-icon-active]="previewDevice === 'tablet'"
                                (click)="setPreviewUrl(url, 'tablet')"
                                style="border-radius: 0px!important;">
                                <i class="fa fa-tablet"></i>
                            </button>
                            <button type="button" class="btn btn-default ltms-display-icon"
                                [class.ltms-display-icon-active]="previewDevice === 'desktop'"
                                (click)="setPreviewUrl(url, 'desktop')"
                                style="border-radius: 0px!important;">
                                <i class="fa fa-desktop"></i>
                            </button>
                        </div>
                        <div class="text-center margin-20"
                            *ngIf="(configuration.flows[previewDevice][default_language]).length==0">
                            <h5> No pages has been configured for <span
                                    style="text-transform: capitalize;">{{previewDevice}}</span>
                            </h5>
                        </div>
                        <div *ngIf="(configuration.flows[previewDevice][default_language]).length" class="preview-container"
                            [ngClass]="previewDevice=='phone'?'phone-preview':(previewDevice=='tablet'?'tablet-preview-studio':'desktop-preview')"
                            >
                            <iframe id="conversationPreviewIframeModalAdvance" style="border: 1px solid #eae5e5;"
                                width="100%" height="500" frameborder="0"></iframe>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="preview-loader" *ngIf="isLoading">
            <app-ltms-loader></app-ltms-loader>
        </div>
    </div>
</div>
